import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import "./ota.css";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import logUserAction from "utils/logging";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import { callUnsetApi } from "utils/api";
const Ota = () => {
  const [firmwareList, setFirmwareList] = useState([]);
  const [version, setVersion] = useState("");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/ota");
    }
  }, [navigate]);
  useEffect(() => {
    fetch("https://api.bharatnet.sunshineiotronics.com/api/v2/ota/versions", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setFirmwareList(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  // Handle delete button click
  const handleDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`https://api.bharatnet.sunshineiotronics.com/api/v2/ota/version/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (response.status === 200) {
              Swal.fire(
                "Deleted!",
                "The software has been deleted.",
                "success"
              );
              toast.success("Software deleted successfully.");
              logUserAction(
                `Deleted Software version: ${firmwareList[index].latest_version_no}`
              );
              setFirmwareList(firmwareList.filter((_, i) => i !== index));
            } else {
              Swal.fire("Failed!", "Failed to delete Software.", "error");
              toast.error("Failed to delete Software.");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            Swal.fire(
              "Error!",
              "An error occurred while deleting the Software.",
              "error"
            );
          });
      }
    });
  };
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    return () => {
      callUnsetApi(siteId);
    };
  }, [siteId]);
  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile.type !== "application/zip") {
      toast.error("Only .zip files are allowed.");
      return;
    }
    setFile(selectedFile);
    toast.success(`Selected file: ${selectedFile.name}`);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".zip",
    multiple: false,
  });
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file || file.type !== "application/zip") {
      toast.error("Please upload a valid zip file.");
      return;
    }

    const formData = new FormData();
    formData.append("latest_version_no", version);
    formData.append("file", file);

    try {
      const response = await fetch(
        "https://api.bharatnet.sunshineiotronics.com/api/v2/ota/version",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        toast.success("Software uploaded successfully.");
        logUserAction(`Uploaded Version: ${version}`);
        setTimeout(() => {
          window.location.reload(); // Reload the page
        }, 2000);
      } else {
        const errorData = await response.json();
        toast.error(`Upload failed: ${errorData.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error uploading Software:", error);
      toast.error("An error occurred while uploading the Software.");
    }
  };

  const breadcrumbs = [
    <Link key="1">Home</Link>,
    <Typography key="2" sx={{ color: "text.primary" }}>
      OTA Upgrade
    </Typography>,
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </div>
        </div>
      </div>
      <br />
      <div className="container-fluid page-body-wrapper">
        <br />
        <form className="form-control" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="verName"
              style={{ fontWeight: "bold", marginBottom: "8px" }}
            >
              Enter New Software Version
            </label>
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              required
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#997d3d",
                  },
                  "&:hover fieldset": {
                    borderColor: "#997d3d",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#997d3d",
                  },
                },
              }}
            />
          </div>
          <div
            {...getRootProps()}
            style={{
              border: "2px dashed #997d3d",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <Typography>Drop the file here...</Typography>
            ) : (
              <Typography>
                Drag and Drop the Latest version or Select the File
              </Typography>
            )}
          </div>
          {file && <Typography mt={1}>Selected File: {file.name}</Typography>}
          <div>
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              sx={{
                marginTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#997d3d",
                  },
                  "&:hover fieldset": {
                    borderColor: "#997d3d",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#997d3d",
                  },
                },
              }}
            >
              Upload
            </Button>
          </div>
        </form>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <br />
        {/* Table for Firmware List */}
        <div className="container-sm my-5 firmware-table-container">
          <Typography variant="h4" className="table-heading">
            Available Softwares
          </Typography>
          <table className="table" id="firmware-table">
            <thead>
              <tr>
                <th scope="col">Sr.No</th>
                <th scope="col">Software Version</th>
                <th scope="col">Software Link</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {firmwareList.length > 0 ? (
                firmwareList.map((firmware, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{firmware.latest_version_no}</td>
                    <td>
                      <a
                        href={firmware.version_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {firmware.version_link}
                      </a>
                    </td>
                    <td className="delete-button">
                      <button
                        class="bin-button"
                        onClick={() =>
                          handleDelete(firmware.latest_version_no, index)
                        }
                      >
                        <svg
                          class="bin-top"
                          viewBox="0 0 39 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <line
                            y1="5"
                            x2="39"
                            y2="5"
                            stroke="white"
                            stroke-width="4"
                          ></line>
                          <line
                            x1="12"
                            y1="1.5"
                            x2="26.0357"
                            y2="1.5"
                            stroke="white"
                            stroke-width="3"
                          ></line>
                        </svg>
                        <svg
                          class="bin-bottom"
                          viewBox="0 0 33 39"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask id="path-1-inside-1_8_19" fill="white">
                            <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                          </mask>
                          <path
                            d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                            fill="white"
                            mask="url(#path-1-inside-1_8_19)"
                          ></path>
                          <path
                            d="M12 6L12 29"
                            stroke="white"
                            stroke-width="4"
                          ></path>
                          <path
                            d="M21 6V29"
                            stroke="white"
                            stroke-width="4"
                          ></path>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No Softwares available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Box>
  );
};

export default Ota;
